import { defineStore } from 'pinia';
import { useToast } from 'vue-toastification';

export const useCartStore = defineStore('cart', {
  state: () => ({
    cartItems: [],
    cartInfo: {},
    countCartItems: 0,
    hold_sale_info: {},
    edit_sale_info: '',
    sale_id: '',
  }),

  getters: {
    cartTotal: (state) => {
      return state.cartItems.reduce((acc, cartItem) => {
        return (cartItem.quantity * cartItem.price) + acc;
      }, 0).toFixed(2);
    },
    cartQuantity: (state) => {
      return state.cartItems.reduce((acc, cartItem) => {
        return cartItem.quantity + acc;
      }, 0);
    }
  },

  actions: {
    UPDATE_CART_ITEMS(payload) {
      const cartItemProduct = JSON.stringify(payload);
      const itemProduct = JSON.parse(cartItemProduct);
      const newCartProduct = {
        product_id: itemProduct.product_id,
        product_stock_id: itemProduct.product_stock_id,
        product_name: itemProduct.product_name,
        mrp_price: itemProduct.mrp_price,
        cost_price: itemProduct.cost_price,
        product_code: itemProduct.product_code,
        discount: itemProduct.discount,
        item_discount: itemProduct.item_discount,
        tax: itemProduct.tax,
        expires_date: itemProduct.expires_date,
        quantity: itemProduct.min_order_qty ? itemProduct.min_order_qty : 1,
        stock_quantity: itemProduct.stock_quantity,
        weight: itemProduct.weight,
        measuring_unit: itemProduct.measuring_unit,
        min_order_qty: itemProduct.min_order_qty,
        uom: itemProduct.measuring_unit,
        dis_array: itemProduct.dis_array,
        convertion_rate: itemProduct.convertion_rate ?? 1,
        purchase_unit_name: itemProduct.purchase_unit_name ?? null,
        sales_unit_name: itemProduct.sales_unit_name ?? null,
      };
      
      let cartProductExists = false;
      this.cartItems.forEach((cartProduct) => {
        if ((cartProduct.product_id === newCartProduct.product_id) && (cartProduct.product_stock_id === newCartProduct.product_stock_id)) {
          cartProduct.quantity++;
          cartProductExists = true;
        }
      });
      if (!cartProductExists) this.cartItems.push(newCartProduct);
    },

    UPDATE_HOLD_ITEMS(payload) {
      const cartItemProduct = JSON.stringify(payload);
      const itemProduct = JSON.parse(cartItemProduct);
      const newCartProduct = {
        product_id: itemProduct.product_id,
        product_stock_id: itemProduct.product_stock_id,
        product_name: itemProduct.product_name,
        mrp_price: itemProduct.mrp_price,
        product_code: itemProduct.product_code,
        discount: itemProduct.discount,
        item_discount: itemProduct.item_discount,
        discount_percent: itemProduct.discount_percent,
        tax: itemProduct.tax,
        expires_date: itemProduct.expires_date,
        quantity: Number(itemProduct.quantity)
      };
      
      let cartProductExists = false;
      this.cartItems.forEach((cartProduct) => {
        if ((cartProduct.product_id === newCartProduct.product_id) && (cartProduct.product_stock_id === newCartProduct.product_stock_id)) {
          cartProduct.quantity++;
          cartProductExists = true;
        }
      });
      if (!cartProductExists) this.cartItems.push(newCartProduct);
    },

    SELECT_CARTINFO(payload) {
      Object.assign(this.cartInfo, payload);
    },

    removeAllFromcart() {
      this.cartItems.splice(0);
      this.hold_sale_info = {};
      this.countCartItems = 0;
    },

    REMOVE_CART_INFO(index) {
      // Intentionally left empty as in original code
    },

    REMOVE_CART_ITEMS(index) {
      this.cartItems.splice(index, 1);
    },

    UPDATE_HOLD_SALE(payload) {
      const proxyToObject = Object.assign({}, payload);
      if (Object.keys(proxyToObject).length > 0) {
        this.hold_sale_info = proxyToObject;
      } else {
        this.hold_sale_info = {};
      }
    },

    addCartItem(cartItem) {
      const toast = useToast();
      this.UPDATE_CART_ITEMS(cartItem);
      toast.success("Added to the cart!", { timeout: 800 });
    },

    addHoldItem(cartItem) {
      this.UPDATE_HOLD_ITEMS(cartItem);
    },

    addHoldSale(cartItem) {
      this.UPDATE_HOLD_SALE(cartItem);
    },

    selectCartInfo(infoData) {
      this.SELECT_CARTINFO(infoData);
    },

    removeCartItem(index) {
      this.REMOVE_CART_ITEMS(index);
    },

    removeCartInfo(index) {
      this.REMOVE_CART_INFO(index);
    },

    removeAllCartItems() {
      this.removeAllFromcart();
    }
  }
});
